export function isImpactDebugModeEnabled() {
  const mode = import.meta.env.MODE;
  if (
    mode === 'development' || // automatic mode from vite for local dev
    mode === 'local-dev' || // since we have defined "local-dev" in vite.config.ts
    mode === 'dev' || // when deployed on dev environment
    mode === 'staging' // when deployed on staging environment
  ) {
    return true;
  } else {
    return false;
  }
}

// mode is defined in the "vite build" command.
// check package.json to see command like: "vite build --mode staging"
